import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { DatePipe } from '@angular/common';

import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { LoanService } from "../../loan/shared/loan.service";

@Component({
  selector: 'app-holidayloan',
  templateUrl: './holidayloan.component.html',
  styleUrls: ['./holidayloan.component.css']
})

export class HolidayloanComponent implements OnInit {

  LoanNo: number = 0;
  LoanTypeList: any[] = [];
  CustomerList: any[] = [];
  SchemeList: any[] = [];
  LoanPurposeList : any[] = [];
  AgentList: any[] = [];
  GroupCustomersList : any[] = [];
  AddButtonText: string;
  ErrorText: string;
  CustomerAddress: string = null;
  dropdownList = [];
  selectedItems: Map<string, Array<any>>;
  readonlyTextBox: boolean = false;
  interestPercentage: number = 0;

  constructor(public loanService: LoanService, private CommonmastersService: CommonmastersService,
    private router: Router, private route: ActivatedRoute, public datePipe: DatePipe) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.LoanNo = +  params['Id']; // (+) converts string 'id' to a number
    });

    this.GetScheme()
    this.GetLoanType();
    this.GetLoanPurpose();
    this.GetAgentList();
    this.GetCustomer();
    // this.GetGroupCustomersList();
    this.selectedItems = new Map<string, Array<any>>();

    if (Number.isNaN(this.LoanNo)) {
      this.loanService.selectedLoan.Id = 0;
      this.loanService.selectedLoan.Flag = 1;
      this.loanService.selectedLoan.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.loanService.selectedLoan.Id = +this.LoanNo;
      this.loanService.selectedLoan.Flag = 2;
      this.loanService.selectedLoan.IsActive = true;
      this.readonlyTextBox = true;
      this.AddButtonText = "Edit & Save";

      this.GetLoanByLoanNo();
    }

    this.GetAutogeneratedNumber();
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.loanService.selectedLoan = {
      Id: 0,
      ApplicationNo: 0,
      CustomerId: 0,
      // ApplicationDate:JSON.parse( new Date().toISOString().substring(0,10)),
      ApplicationDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      CustomerName: ' ',
      Schemename: ' ',
      Centername: ' ',
      LoanTypeId: 1,
      SchemeId: 0,
      MinValue: null,
      MaxValue: null,
      IRRInterest: null,
      FlatInterest: null,
      InterestType: "0",
      LoanAmount: 0,
      InterestAmount: null,
      Category: ' ',
      LoanPurposeId: 0,
      IsJoint: null,
      JointLoanee: ' ',
      Remarks: 'Holiday Loan - ',
      AgentId: 0,
      LoanApprovedStatusId: null,
      DDFund  : 0,
      LoanApprovedBy: null,
      LoanApprovedDate:  new Date(),
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: true,
      Flag: 1,
      IsCustomerSearch: true,
      IsApprovalClick: false,
      Recommendation: null,
      ApprovedRemarks: null,
      CustomerAddress: null,
      SearchByApprovedStatus: null,
      PreSavingsAmount : null,

      // for Report
      FromDate: null,
      ToDate: null,
      BranchId: 0,
      CentreId: 0,
      loanCategoryId: 0,
      ReportName: null,
      IsLoanPreclosure: false,
      IsCentreORCustomerWise: null,
      PaymentTypeId: 0,
      PaymentBankId: 0,
      IsOpening: false,
      IsRejoin: false,
      //LoanPreApprovedDate: new Date().toISOString().substring(0,10),
      LoanPreApprovedDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]
    }
  }

  onSubmit(form: NgForm) {

    // if (form.value.CustomerId != null) {
    if (this.loanService.selectedLoan.CustomerId != null) {
      // this.loanService.IUDLoan(this.loanService.selectedLoan)
      this.loanService.IUDLoan(form.value)
        .toPromise()
        .then(data => {
          // this.resetForm(form);
          // this.loanService.FetchLoanList();
          this.router.navigate(['/loanlist']);
        })
    }
  }

  GetLoanByLoanNo() {
    if (this.loanService.selectedLoan.Id !== 0) {
      // this.loanService.selectedLoan.Id =+ this.loanService.selectedLoan.Id;
      this.loanService.FetchLoanByLoanNo(this.loanService.selectedLoan).subscribe(data => {
        this.loanService.selectedLoan = data;
        this.loanService.selectedLoan.Flag = 2;
        this.SelectSchemeChange(data.SchemeId)

      })
    }
  }

  GetAutogeneratedNumber(): any {
    if (this.loanService.selectedLoan.Id === 0) { // Parent Loan No number checks
      const myAutoGeneratedId = this.CommonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.loanService.selectedLoan.ApplicationNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      this.loanService.selectedLoan.ApplicationNo = + this.LoanNo;
    }
  }

  GetScheme() {
    this.CommonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;
    })
  }

  public SelectSchemeChange(SchemeId: any) {
    this.loanService.FetchSchemeBySchemeId(SchemeId).subscribe(data => {
      // this.SchemeDetails = data;
      // this.loanService.selectedLoan.MinValue = data.MinValue;
      // this.loanService.selectedLoan.MaxValue = data.MaxValue;
      // this.loanService.selectedLoan.InterestPrecentage = data.InterestPrecentage;
      this.loanService.selectedLoan.FlatInterest = data.InterestPrecentage;
      this.loanService.selectedLoan.InterestType = data.PeriodType;
      this.loanService.selectedLoan.InterestAmount = data.IntallmentAmount;
      this.loanService.selectedLoan.Category = data.LoanCategoryName;

      this.interestPercentage = data.InterestPrecentage; // finding interest amount
      if (this.loanService.selectedLoan.LoanAmount != null) {
        this.loanService.selectedLoan.InterestAmount = (this.loanService.selectedLoan.LoanAmount * (this.interestPercentage / 100));
      }
    })
  }

  public SelectInterestAmount(amount: any) {

    this.loanService.selectedLoan.InterestAmount = amount * (this.interestPercentage / 100);
  }

  GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetLoanPurpose() {
    this.CommonmastersService.FetchLoanPurpose().subscribe(data => {
      this.LoanPurposeList = data;
    })
  }

  GetAgentList() {
    this.CommonmastersService.FetchAgentList().subscribe(data => {
      this.AgentList = data;
    })
  }

  GetCustomer() {
    // this.loanService.selectedLoan.SearchByApprovedStatus =
    this.loanService.FetchCustomerList().toPromise().then(data => {
      this.CustomerList = data;
      this.GetGroupCustomersList(data[0].GroupId);
    })
  }

  GetGroupCustomersList(memberGroupId : any){
    this.GroupCustomersList = this.CustomerList.filter(item => item.GroupId == memberGroupId);    
  }

  selectWitnessChange($event: Event) {
    // console.log($event);
    // console.log($event["GroupId"]);
    this.CustomerAddress = null;
    this.GroupCustomersList = [];
    this.GroupCustomersList.length = 0;
    this.GetGroupCustomersList($event["GroupId"]);
    this.CustomerAddress = $event["CustomerAddress"];
    //    this.GetCustomerAddressById(this.loanService.selectedLoan.CustomerId);
  }

  GetCustomerAddressById(CustomerId: any) {
    this.loanService.GetCustomerAddressById(CustomerId).subscribe(data => {
      this.CustomerAddress = data.Address + ' , ' + data.Place + ' , ' +
        data.Postoffice + ' , ' + data.District;

    })
  }
}

